import { object, string } from 'yup';

import { createValidator } from '@src/validation';
import { reportPeriodsStore } from '@stores/dictionaryStores/reportPeriodsStore';

const validateSchema = object().shape({
  reportGroupCode: string()
    .nullable()
    .required()
    .test(
      'reportGroupCode',
      'Пара код группы отчетных форм и код периода должна быть уникальной',
      (value, { parent: { periodCode, id } }) => {
        const { reportPeriods } = reportPeriodsStore;
        return !reportPeriods
          .filter((reportPeriod) => `${reportPeriod?.periodCode}-${reportPeriod?.reportGroupCode}` !== id)
          .some((reportPeriod) => reportPeriod.reportGroupCode === value && reportPeriod.periodCode === periodCode);
      },
    ),
  periodCode: string()
    .nullable()
    .required()
    .test(
      'periodCode',
      'Пара код группы отчетных форм и код периода должна быть уникальной',
      (value, { parent: { reportGroupCode, id } }) => {
        const { reportPeriods } = reportPeriodsStore;
        return !reportPeriods
          .filter((reportPeriod) => `${reportPeriod?.periodCode}-${reportPeriod?.reportGroupCode}` !== id)
          .some(
            (reportPeriod) => reportPeriod.reportGroupCode === reportGroupCode && reportPeriod.periodCode === value,
          );
      },
    ),
  preparationMonthCode: string().required(),
  preparationDay: string().required(),
  disclosureMonthCode: string()
    .required()
    .nullable()
    .test(
      'disclosureMonthCode',
      'Месяц раскрытия отчетности не может быть раньше месяца подачи отчетности',
      (value, { parent: { preparationMonthCode } }) => {
        if (value === '1' && preparationMonthCode === '12') return true; // после Декабря (месяц подачи отчетности) можно установить Январь (месяц раскрытия отчетности)
        return value ? Number(value) >= Number(preparationMonthCode) : true;
      },
    ),
  dueDay: string()
    .required()
    .nullable()
    .test(
      'dueDay',
      'День месяца раскрытия отчетности не может быть раньше дня месяца подачи отчетности',
      (value, { parent: { disclosureMonthCode, preparationMonthCode, preparationDay } }) => {
        if (value && disclosureMonthCode && preparationMonthCode && disclosureMonthCode === preparationMonthCode) {
          return Number(value) >= Number(preparationDay);
        }

        return true;
      },
    ),
});

export const validate = createValidator(validateSchema);
